import React from 'react';
import './Appointment.css';
import Calender from './Calendly';

function Appointment() {
 return (
    <>
        <div className='container-appt'>

        <div className='class-appt'>
            <img src='./images/profile.jpg' alt='profile' />
        
        </div>
        <div className='class-appt-text'>
            <h5>Nutritionist</h5>
            <h1>Nutritionist Sarah Flores</h1>
            <i class="fa-solid fa-medal"></i><span>Highly Recommended</span>
           <br/> <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><span>52 Reviews</span>
            
            <br/><span>834 Visits</span>

            <br/> <pre>
                        Nutritionist with 3 years of experience in nutrition and dietetics. Dedicated to improving
            dietary habits and long-term health for people of all ages with different diseases.
            Enthusiastic and outgoing with proven ability to motivate through education and positivity.
            Committed to researching and gathering information on clients' physical fitness, stress
            levels, medical diagnoses and medication usage.
                </pre>

        </div>
        </div>
        <div className='index-container'>
        <a className='button-catalog' href="https://www.instagram.com/sarahfloresnutricion/" target='blank' ><i class="fa-brands fa-instagram"></i>Instagram</a>
        <a className='button-catalog' href="https://wa.me/+50496049447?text=Hola, visité su página y me gustaría obtener información sobre sus servicios."  target='blank'><i class="fa-brands fa-whatsapp"></i>Whatsapp</a>
        <a className='button-catalog' href="https://www.facebook.com/sarahfloresnutricion" target='blank'><i class="fa-brands fa-facebook-square"></i>Facebook</a>
        <Calender />

        </div>
    </>
  )
}

export default Appointment